import React from 'react';
import {MobileHeader} from './NavigationTabs/MobileHeader';
import {getHeader} from "../../spirsApi/api-client";
import {CHANGE_THEME} from "../../store/spirs/actions";
import {HeaderType, ThemeType} from "../../models/api/codegen/code";
import {useDispatch, useSelector} from "react-redux";
import {StoreType} from "../../store/spirs/types";

type DesktopHeaderProps = {
    toggleVerticalMenu: () => void;
};

export const HeaderMaterial = (props: DesktopHeaderProps) => {
    const [header, setHeader] = React.useState<HeaderType | undefined>(undefined);
    const theme = useSelector((store: StoreType) => store.theme);
    const dispatch = useDispatch();
    React.useEffect(() => {
        const lsTheme = localStorage.getItem("theme");
        getHeader().then(data => {
            if (!data) {
                return;
            }
            setHeader(data)
            const newTheme = lsTheme && !data.theme.force ? lsTheme : data.theme.type;
            dispatch(CHANGE_THEME({...theme, type: newTheme as ThemeType, switchTheme: data.theme.switchTheme}));

        })
    }, [])

    return (
        <div >
            {header && <div className="tablet:hidden">
                <MobileHeader header={header} toggleVerticalMenu={props.toggleVerticalMenu}/>
            </div>}
            {header && <div className="max-mobile:hidden">
            </div>}
        </div>
    );
};
